module.exports = __webpack_public_path__ + "img/p2.cdf4a271.png";